/**
 * This is a wrapper that checks if the *props.to* field exsits and if it does wrap the children in a Link
 * It will handle external links
 */

import React from 'react'
import { Link as RRLink } from 'react-router-dom'
import filterString from '../filterString'
import isEmpty from 'lodash/isEmpty'
import { withRouter } from 'react-router-dom'

/**
 * Programatically handle links to other pages. 
 * 
 * NOTE: 2021-04 Added linkURL to.to, if you see strange behaviour from this component this might be it. We added support for "string-only" link by supporting to to just be a string and not an object with to.to
 * 
 * TODO: Fix more logic to support external links
 * TODO: Currently you have to wrap the parent component in withRouter, fix that we do not need this
 */
export const link = (to,props) => {
    const linkUrl = to.to ? to.to : to
    props.history.push(linkUrl)
}

export const onClickLink = ( (url,history, cleanupFunc) => e => {

    if( ! url ) {
        return
    }

    if( typeof url === 'string' ) {
        history.push({
            pathname : `${url}`,
            search: ''
        })
    }

    if( ! url.to ) {
        return
    }

    if( url.browserBack ) {
        history.goBack()
    }

    if( url.isExternal ) {
        window.location = `${url.to}${url.params ? url.params : ''}`
        return
    }

    // history.push(`${url.to}${url.params ? url.params : ''}`)
    history.push(`${url.to}`)

    if( cleanupFunc ) {
        cleanupFunc()
    }

})

const Link = withRouter((props) => {
    const { to, children,history, className, width } = props

    //if to is string, this is the "OLD" way of doing it, so this is just to support old-style
    if( typeof to === 'string') {
        return <RRLink style={{width}} className={className} to={to}>{children}</RRLink>
    }

    if( isEmpty(to)) {
        return children
    }

    if( to.browserBack ) {

        return <a className={className} href="javascript:void(0)" onClick={() => history.goBack()}>{children}</a>
    }

    if( to.isExternal ) {

        return <a style={{width}} className={className} target={to.isTargetBlank ? '_blank' : '_self'} href={`${filterString(to.to,props)}${to.params ? '?' + filterString(to.params,props) : ''}`}>{children}</a>
    } else {

        return <RRLink style={{width}}className={className} to={`${filterString(to.to,props,props)}${to.params ? '?' + filterString(to.params,props,props) : ''}`}>{children}</RRLink>
    }
})

export default Link